import React, { Suspense, lazy, useState } from "react";
import { Clapperboard, Loader2 } from "lucide-react";
import { publicShowApi } from "@/components/nds/windows/showcase/showKit";

const ShowcasePlayer = lazy(() => import("@/components/nds/windows/showcase/ShowcasePlayer"));

/** Public "Watch the Platform": full-screen narrated Platform Showcase, no login. */
export default function WatchPlatformButton({ className = "", style }) {
  const [show, setShow] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(false);
  const open = () => {
    document.documentElement.requestFullscreen?.().catch(() => {});
    setBusy(true); setErr(false);
    publicShowApi.get().then(setShow).catch(() => { setErr(true); if (document.fullscreenElement) document.exitFullscreen().catch(() => {}); }).finally(() => setBusy(false));
  };
  const exit = () => { setShow(null); if (document.fullscreenElement) document.exitFullscreen().catch(() => {}); };
  return (
    <>
      <button type="button" onClick={open} disabled={busy} data-testid="hero-cta-watch-platform" className={className} style={style} title={err ? "Couldn't load the showcase. Try again." : undefined}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Clapperboard className="h-4 w-4" />} {err ? "Try again" : "The System"}
      </button>
      {busy && <div data-testid="watch-platform-loading" className="fixed inset-0 z-[9999] grid place-items-center bg-[#0B0F19] text-nex-gold"><Loader2 className="h-8 w-8 animate-spin" /></div>}
      {show && <Suspense fallback={null}><ShowcasePlayer show={show} segIdx={show.segments.map((_, i) => i)} onExit={exit} api={publicShowApi} intro /></Suspense>}
    </>
  );
}
